import { render, staticRenderFns } from "./PersonInfos.vue?vue&type=template&id=5a74bd3e"
import script from "./PersonInfos.vue?vue&type=script&lang=js"
export * from "./PersonInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports